// extracted by mini-css-extract-plugin
export default {"container":"Script_container__bBYNe","iframe":"Script_iframe__46DGZ"};